import { useEffect } from "react";
import ShadowCard from "components/common/cards/ShadowCard";
import { useForm } from "contexts/FormContext";
import CnFormAddressFields from "./CnFormAddressFields";

export default function CnFormShippingAddressSection({
  states = [],
  cities = [],
  counties = [],
  data,
}) {
  const { form, validateForm } = useForm();

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form.ShipState,
    form.ShipCity,
    form.ShipCounty,
    form.ShipStreet1,
    form.ShipStreet2,
  ]);

  const {
    title,
    text1,
    text2,
    inputModelArray: {
      0: {
        fields: { listArray },
      },
    },
  } = data.fields;

  return (
    <ShadowCard label={title}>
      <div className="form-max flex-20 column" id="address-section">
        <p className="address-country">
          {text1}
          <strong>{text2}</strong>
        </p>
        <CnFormAddressFields
          addressType="Ship"
          states={states}
          cities={cities}
          counties={counties}
          listArray={listArray}
        />
      </div>
    </ShadowCard>
  );
}
